import { bootstrapApplication } from '@angular/platform-browser';
import { APP_INITIALIZER } from '@angular/core';
import {
  RouteReuseStrategy, provideRouter,
  withPreloading, PreloadAllModules, withHashLocation,
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiInterceptor } from './app/core/api.interceptor';
import { analyticsInterceptor } from './app/core/interceptors/analytics.interceptor';
import { TokenService } from './app/core/services/token.service';
import { CityService } from './app/core/services/city.service';
import { TrackingService } from './app/core/services/tracking.service';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({ mode: 'md' }),  // Material Design on all platforms
    provideRouter(routes, withPreloading(PreloadAllModules), withHashLocation()),
    provideHttpClient(withInterceptors([apiInterceptor, analyticsInterceptor])),
    {
      // Resolve the active city (geolocation → bbox) before the app makes any
      // API call, so requests hit the right silo. Runs once at startup.
      provide: APP_INITIALIZER,
      useFactory: (city: CityService) => () => city.resolve(),
      deps: [CityService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (ts: TokenService) => () => ts.init(),
      deps: [TokenService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (tracking: TrackingService) => () => tracking.init(),
      deps: [TrackingService],
      multi: true,
    },
  ],
}).catch(err => console.error('[Bootstrap] Failed:', err));
